var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionEnterprise5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1864_34904",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b791d1b92b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H80V80H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1864_34904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.7363 0.261769C63.2466 0.0674303 51.9863 5.35343 40.1164 14.6324C31.9785 8.48357 24.0498 4.09153 17.4072 2.04709C10.7621 6.02305e-05 5.72593 0.404283 2.97541 3.20016C0.235226 6.00382 -0.08244 11.0644 2.06374 17.6952C4.2125 24.326 8.71921 32.2058 14.9795 40.2669C8.85351 48.4317 4.47593 56.3841 2.43564 63.0486C0.397932 69.7131 0.800825 74.7685 3.58492 77.5255C6.37934 80.2773 11.4232 80.5986 18.0322 78.4454C24.6412 76.2921 32.495 71.7679 40.5322 65.4869C48.6701 71.6331 56.5963 76.0252 63.2388 78.0696C69.8814 80.1141 74.9175 79.7098 77.6655 76.914C80.4108 74.1155 80.7337 69.0549 78.5875 62.4241C76.4413 55.7933 71.9346 47.9135 65.6743 39.8498C71.8003 31.6824 76.1805 23.7275 78.2156 17.063C80.2533 10.3985 79.8478 5.34566 77.0586 2.58865C75.571 1.12204 73.4351 0.334322 70.7363 0.261769Z",
    fill: "#D7D3F7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionEnterprise5);
export default __webpack_public_path__ + "static/media/icon-section-enterprise-5.0531fd5f3394e8fe44374c8b9bb8661cd855b42dd3af86a92896d2f12dd78b09.svg";
export { ForwardRef as ReactComponent };